import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useModal } from '../hooks/useModal';
import { selectUser, selectRole, selectUserId, selectUsername, selectUserList, selectRouteSimple } from '../redux/selectors';
import FormLogin from './FormLogin';
import { actionAuthLogout, actionAuthFormLogin } from '../redux/auth-actions';
import { actionUserListNeeded } from '../redux/actions';
import Btn from './Btn';
import Komentar from './Komentar';
import ColumnWidth from './ColumnWidth';
import SpinnerRow from './SpinnerRow';


const StranaWelcome = (props) => {
  const dispatch = props.dispatch;
  const { dispatchShowModal, dispatchCloseModal, dispatchShowToast } = useModal();
  const route = props.route;

  useEffect(() => {
    // svaki put pozivamo supervalidator kada se freshness promeni
    dispatch(actionUserListNeeded());
  }, [route.freshness]); // Only re-run the effect if freshness changes

  let jsxSpinnerKorisnici = (
    <SpinnerRow />
  );
  let korisnici = [];
  if (props.userList.fetching === false) {
    if (Array.isArray(props.userList.data)) {
      korisnici = props.userList.data;
      jsxSpinnerKorisnici = null;
    }
  }


  const role = props.role;
  let jsx = null;
  if (role === 'GUEST') {
    jsx = (
      <p>Status: niste ulogovani</p>
    );
  } else {
    jsx = (
      <p>Status: vaša uloga je <b>{role}</b></p>
    );
  }


  const _prikaziLoginFormu = () => {
    let _cbSubmit = (entbox) => {
      // console.log(entbox);
      if (!(typeof entbox.password === 'string')) {
        entbox.password = '';
      }
      //
      dispatch(actionAuthFormLogin(entbox));
      dispatchCloseModal();
    };
    const modalContent = (
      <FormLogin
        submit={_cbSubmit}
      />
    );
    dispatchShowModal(modalContent);
  };

  const _logout = () => {
    const user_id = props.userId;
    dispatch(actionAuthLogout(user_id));
  }

  let jsxButtons = null;
  let jsxFormLogin = null;
  if (props.user.ulogovan === true) {
    jsxButtons = (
      <Btn
        title="Izloguj se"
        i="fa fa-sign-out"
        handleClick={_logout}
      />
    )
  } else {
    let _cbSubmit = (entbox) => {
      // console.log(entbox);
      if (!(typeof entbox.password === 'string')) {
        entbox.password = '';
      }
      //
      dispatch(actionAuthFormLogin(entbox));
      // dispatchCloseModal();
    };
    jsxFormLogin = (
      <FormLogin submit={_cbSubmit} />
    );
    /*
    jsxButtons = (
      <Btn
        title="Uloguj se"
        i="fa fa-unlock"
        handleClick={_prikaziLoginFormu}
      />
    );
    */
  }


  let korisniciFiltered = []
  if (Array.isArray(korisnici)) {
    korisniciFiltered = korisnici.filter((item) => {
      if (item.activated === true) {
        return true; // only activated user
      }
      return false;
    });
  }


  return (
    <>
      <ColumnWidth w={480}>
        <h2>Dobrodošli {props.username}</h2>
        {jsx}
        <ColumnWidth w={250}>
          {jsxFormLogin}
        </ColumnWidth>
        {jsxButtons}
        <Komentar>Za većinu korisnika sa spiska ispod password je "Termo123". Za korisnike admin, dev i tester, lozinka je ista kao korisničko ime.</Komentar>
        <div>
          <h3>Lista aktiviranih korsnika</h3>
          {
            Array.isArray(korisniciFiltered) && (
              korisniciFiltered.map((item) => {
                return (
                  <div><span>{item.id}</span>&nbsp;&nbsp;<b>{item.username}</b>{item.role === 'ADMIN' ? (<>&nbsp;&nbsp;<b className="text-red">ADMIN</b></>) : (null)}</div>
                );
              })
            )
          }
          {jsxSpinnerKorisnici}
        </div>
      </ColumnWidth>
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: selectUser(state),
    role: selectRole(state),
    username: selectUsername(state),
    userId: selectUserId(state),
    userList: selectUserList(state),
    route: selectRouteSimple(state)
  };
}
export default connect(mapStateToProps)(StranaWelcome);
